import { render, staticRenderFns } from "./Assistance.vue?vue&type=template&id=ccdda2ca&scoped=true&"
import script from "./Assistance.vue?vue&type=script&lang=js&"
export * from "./Assistance.vue?vue&type=script&lang=js&"
import style0 from "./Assistance.vue?vue&type=style&index=0&id=ccdda2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdda2ca",
  null
  
)

export default component.exports